import React from 'react';

const Modal = ({showModal, As, ...props}) => {
    if (!showModal) return null;

    return <As showModal={showModal} {...props} />
};

export default Modal;
